import React, { useContext, useState } from "react";
import Registro from "./Registro";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";
import {
  OverlayTrigger,
  Tooltip,
  Dropdown,
  DropdownButton,
  Form,
  Alert,
  Badge,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import "./style.scss";
import { Icon } from "@iconify/react";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import boxAdd from "@iconify/icons-icomoon-free/box-add";
import arrowDownAlt2 from "@iconify/icons-dashicons/arrow-down-alt2";
import DommusLoadingArea from '../../../components/DommusLoading/DommusLoadingArea';
import InfiniteScroll from 'react-infinite-scroll-component';
import Swal from "sweetalert2";
import caAPI from "../../../services/caAPI";
import { trackPromise } from "react-promise-tracker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { infoToast, successToast } from "../../../components/DommusToast";
import { BrowserView } from "react-device-detect";
import { DommusCustomDragOverlay } from "../../../components/DommusCustomDragOverlay";
import { DommusCardAtendimentoDrag } from "../../../components/DommusCardAtendimentoDrag";
import DommusLoadingCardAtendimento from "../../../components/DommusLoading/DommusLoadingCardAtendimento";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import DommusLoading from "../../../components/DommusLoading/DommusLoading";

export default function RegistroAtendimento({
  abrirAtendimento,
  atendimentoAtivoId
}) {

  const { listaAtendimentos, filtro, setListaAtendimentos, totalAtendimentos, naoAtendidos, pagina, setPagina, 
            fetchingLista, setFetchingLista, atualizarAtendimentoLista, filtroSomenteNaoLidas, setAtendimentoAtivo, buscarSomenteNaoLidas, totalAtendimentosGeral, idDragActive, buscandoAtendimentos } = useContext(AtendimentoContext);
  const [multiSelection, setMultiSelection] = useState(false);
  const [atendimentosSelecionados, setAtendimentosSelecionados] = useState([]);  

  const fetchScroll = () => {
    setFetchingLista(true);
    const paginaBusca = pagina + 1;
    trackPromise(caAPI.atendimento.filtro.filtrar(filtro, paginaBusca).then(res => {
      if(Array.isArray(res.data) && res.data.length){
        const novaLista = listaAtendimentos.concat(res.data);
        setListaAtendimentos(novaLista);
        setPagina(paginaBusca);
        setTimeout(function () {
          setFetchingLista(false);

        }, 10);
      }
    }).catch(err => {
      Swal.fire({
        titleText: "Erro",
        text: "Não foi possivel buscar os dados filtrados",
        icon: 'error'
      });
    }), "filtroArea")
  };

  const limparSelecao = () => {
    document.querySelectorAll('#checkboxRegistro').forEach(check => check.checked = false);
  }

  const handleArquivamentoEmMassa = () => {
    if(!atendimentosSelecionados?.length){
      infoToast.fire("Nenhum atendimento selecionado!!!");
      return
    }
    const payload = { 
      ids_atendimento: atendimentosSelecionados
    }
    Swal.fire({
        titleText: `Deseja arquivar o(s) ${atendimentosSelecionados?.length.toString().padStart(2, '0')} atendimento(s) selecionados?`,
        text: "Confime realização da ação.",
        icon: "question",
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "Sim, arquivar!",
        cancelButtonText: "Não, mantenha.",
        customClass: {
          confirmButton: "btn btn-primary mr-3",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        trackPromise(
          caAPI.atendimento.acaoEmMassa('arquivar',payload).then(res => {
            setListaAtendimentos((current) => current.filter((item) => !atendimentosSelecionados.includes(item.id)))
            setAtendimentoAtivo(null)
            setAtendimentosSelecionados([]);
            limparSelecao()
            successToast.fire("Atendimentos arquivados com sucesso!!!");
          }).catch(err => {
            Swal.fire({
              titleText: "Erro",
              text: "Erro ao arquivar os atendimentos",
              icon: 'error'
            });
          })
        )
      }
    });
  }

  const handleRemoverAtendimentosEmMassa = () => {
    if(!atendimentosSelecionados?.length){
      infoToast.fire("Nenhum atendimento selecionado!!!");
      return
    }
    const payload = { 
      ids_atendimento: atendimentosSelecionados
    }
    Swal.fire({
        titleText: `Deseja remover o(s) ${atendimentosSelecionados?.length.toString().padStart(2, '0')}  atendimento(s) selecionados?`,
        text: "Confime realização da ação.",
        icon: "question",
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "Sim, remover!",
        cancelButtonText: "Não, mantenha.",
        customClass: {
          confirmButton: "btn btn-primary mr-3",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        trackPromise(
          caAPI.atendimento.acaoEmMassa('remover',payload).then(res => {
            setListaAtendimentos((current) => current.filter((item) => !atendimentosSelecionados.includes(item.id)))
            setAtendimentoAtivo(null)
            setAtendimentosSelecionados([]);
            limparSelecao()
            successToast.fire("Atendimentos removidos com sucesso!!!");
          }).catch(err => {
            Swal.fire({
              titleText: "Erro",
              text: "Erro ao remover os atendimentos",
              icon: 'error'
            });
          })
        )
      }
    });
  }

  const handleSelectMulti = () => {
    setMultiSelection(!multiSelection);
    setAtendimentosSelecionados([]);
  };

  const handleSelecionaAtendimento = (novaSelecao) => {
    let value = [...atendimentosSelecionados];
    if (
      atendimentosSelecionados.filter(
        (atendimento) => atendimento === novaSelecao
      ).length
    ) {
      const index = atendimentosSelecionados.findIndex(
        (atendimento) => atendimento === novaSelecao
      );
      value.splice(index, 1);
    } else {
      value.push(novaSelecao);
    }
    if (multiSelection) {
      setAtendimentosSelecionados(value);
    } else {
      setAtendimentosSelecionados();
    }
  };

  function menu() {
    return (
      <>
        <div className="menuAtendimento">
          <OverlayTrigger
            key="buttonMenuAtendimento"
            placement="top"
            overlay={<Tooltip id={`tooltip-editar`}> Ações em massa </Tooltip>}
          >
            <DropdownButton
              id="DropAtendimento"
              size="sm"
              title={<Icon icon={arrowDownAlt2} width="3rem" />}
            >
              <Dropdown.Item className="opcaoMenu" onClick={() => {
                handleArquivamentoEmMassa()
              }}>
                <div className="opcaoArquivar">
                  <Icon icon={boxAdd} />
                  <span className="tituloArquivar"> Arquivar </span>
                </div>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item className="opcaoMenu" onClick={() => {
                handleRemoverAtendimentosEmMassa()
              }}>
                <div className="opcaoExcluir">
                  <FontAwesomeIcon icon={faTrash} />
                  <span className="tituloExcluir"> Excluir </span>
                </div>
              </Dropdown.Item>
            </DropdownButton>
          </OverlayTrigger>
        </div>
      </>
    );
  }

  const titulo = () => {
    return (
      <div className="atendimentos-titulo">
        <div className="dados-section">
          <Form.Check
            id="toggleCheckMultiSelect"
            checked={multiSelection}
            value={multiSelection}
            onChange={() => handleSelectMulti()}
          ></Form.Check>
          {multiSelection ? <div className="multiSelect"> {menu()} </div> : <></>}
          <div className="titleToggleAtendimentoContent">
            <BrowserView>
              <div className="totalAtendimentos">
                Atendimentos
              </div>
            </BrowserView>
          </div>
        </div>
        <ButtonGroup>
          <Button 
            className={`btn-visualizacao-atendimento ${!filtroSomenteNaoLidas && "selecionado"}`} 
            disabled={buscandoAtendimentos}
            onClick={()=>{buscarSomenteNaoLidas(false)}}
          >
            <Badge variant="light">{totalAtendimentosGeral ?? totalAtendimentos}</Badge><span>Todos</span>
          </Button>
          <Button 
            className={`btn-visualizacao-atendimento ${filtroSomenteNaoLidas && "selecionado"}`} 
            disabled={buscandoAtendimentos}
            onClick={()=>{buscarSomenteNaoLidas(true)}}
          >
            <span>Não vistos</span><Badge variant="light">{naoAtendidos}</Badge>
          </Button>
        </ButtonGroup>
      </div>
    );
  };

  return (
    <div className="atendimentos-lista-section">
      {titulo()}
      <div id="scrollContainer" className="dommus-toggle-height-fixed-atendimento">
        <DommusLoadingArea area="listaAtendimentosArea" fundo={"#fff"} />
          <div className="registros-container w-100">
            <InfiniteScroll
              dataLength={listaAtendimentos.length || 0} //This is important field to render the next data
              next={fetchScroll}
              hasMore={!(fetchingLista) && ( (listaAtendimentos.length || 0) < totalAtendimentos )}
              loader={<DommusLoading loadWrapperPosition={"relative"} fundo="transparent"/>}
              style={{ minHeight: '350px'}}
              endMessage={((fetchingLista) && 
                <Alert variant={'info'} className="alert-section">
                  <strong>Carregando ...</strong>
                </Alert> 
                ) || listaAtendimentos?.length && 
                <Alert variant={'warning'} className="alert-section"><strong>Não há mais atendimentos a carregar!</strong></Alert> ||
                <Alert variant={'warning'} className="alert-section"><strong>Nenhum atendimento à ser exibido</strong></Alert>
              }
              scrollThreshold={0.5}
              scrollableTarget="scrollContainer">
              <TransitionGroup>
                {listaAtendimentos?.length && listaAtendimentos.map((registro, index) => (
                  <CSSTransition key={`${registro.id}`} timeout={500} classNames={`animacao-entrada`}>
                    <div className="registroSection">
                      <DommusLoadingCardAtendimento area={`atendimento-${registro.id}-${index}`}>
                        {multiSelection && (
                          <div className="checkboxAtendimentosArea">
                            <Form.Check
                              id="checkboxRegistro"
                              className="checkbox-atendimentos"
                              type="checkbox"
                              value={registro.id}
                              onChange={() => handleSelecionaAtendimento(registro.id)}
                            />
                          </div>
                        )}
                        <Registro
                          posicaoListaAtentimentos={index}
                          registro={registro}
                          abrirAtendimento={abrirAtendimento}
                          atendimentoAtivoId={atendimentoAtivoId}
                          key={registro.id}
                          atualizarAtendimentoLista={atualizarAtendimentoLista}
                          index={index}
                        />
                      </DommusLoadingCardAtendimento>
                      {`atendimento-${registro.id}-${index}` === idDragActive && (
                        <DommusCustomDragOverlay>
                          <DommusCardAtendimentoDrag atendimento={registro} />
                        </DommusCustomDragOverlay>
                      )}
                    </div>
                  </CSSTransition>
                ))}
              </TransitionGroup>
            </InfiniteScroll>
          </div>
      </div>
    </div>
  );
}
